import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import { getAmplifyConfig } from "./amplifyConfig";
import { GlobalProvider } from "./context/GlobalContext";

const callbackURL = window.location.origin;
// `graphql_headers` is supplied by the shared `buildGraphqlHeaders` builder wired
// into every env config variant in amplifyConfig.ts. It preserves the existing
// Cognito Authorization token and additionally attaches the audit context header
// to every operation (Req 1.2), so no override is done here (single source of
// truth, no drift).
const configObj = getAmplifyConfig(callbackURL);
Amplify.configure(configObj);
console.log("Amplify configured with dynamic config");
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalProvider>
      <App />
    </GlobalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
